<div class="v-pageName">Try Now</div>

<!-- Client data -->
<div class="body-main">
    <div class="qmig-card">
        <div class="qmig-card-body">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <h3 class="mb-3 main_h">Source File</h3>
                    <textarea rows="40" class="form-control" disabled>{{sourceData}}</textarea>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <h3 class="mb- main_h">Target File</h3>
                    <textarea rows="40" class="form-control" #output>{{outputData}}</textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 offset-md-6 mt-3">
                    <button type="button" class="btn btn-upload w-100" (click)="updateTryNow(output.value)"><span class="mdi mdi-content-save"></span> &nbsp;Save Data</button> 
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 mt-3 ">
                    <button type="button" class="btn btn-sign w-100" (click)="sendMail(output.value)" > <span class="mdi mdi-email-outline"></span> &nbsp; Send Mail</button>
                </div>
            </div>
        </div>
    </div>
</div>